export interface IReportStepOneProps {
  reports: any[];
  reportsLoader: any;
  reportsRequest: () => {};
  modifySelectedReport: (report: {}) => {};
  ReportRequest: () => {};
  resetReportState: () => {};
  goBack: () => {};
}

export const TypeFilter = {
  idFilter: "id",
  nameFilter: "name",
  descriptionFilter: "description",
};

export const REPORT_FORM_FILTER: string = "ReportFormFilter";

export const mockUsers: any[] = [
  {
    id: 1,
    name: "Report1",
    description: "Lorem Ipsum",
  },
  {
    id: 2,
    name: "Report2",
    description: "Lorem Ipsum",
  },
];
